import * as vp from 'vopay';
import { useEffect, FunctionComponent, useState } from 'react';
import useFetchCurrencyConversionTransaction from '../../../../hooks/useApi/useFetchCurrencyConversionTransaction';
import CurrencyConversionTransactionInfo from './CurrencyConversionTransactionInfo';

type CurrencyConversionTransactionContainerProps = vp.TransactionId & { jwt: string };

type FC = FunctionComponent<CurrencyConversionTransactionContainerProps>;

const CurrencyConversionTransactionContainer: FC = (props: CurrencyConversionTransactionContainerProps) => {
  const { TransactionID, jwt } = props;
  const [currencyConversionTransaction, getCurrencyConversionTransaction] = useFetchCurrencyConversionTransaction({ bearer: jwt });
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.CurrencyConversionTransactionList>();

  useEffect(() => {
    getCurrencyConversionTransaction({
      TransactionID: TransactionID,
    });
  }, [currentTransactionId]);

  useEffect(() => {
    if (currencyConversionTransaction) {
      setTransaction(currencyConversionTransaction.Transactions);
    }
  }, [currencyConversionTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return <div>{transaction && <CurrencyConversionTransactionInfo transaction={transaction} />}</div>;
};

export default CurrencyConversionTransactionContainer;
